import SearchIcon from '@mui/icons-material/Search';
import {
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Toolbar,
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
  marginLeft: 'auto',
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: 320,
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

export default function ListToolbar({
  filterName,
  onFilterName,
  userType,
  handleUserTypeChange,
}) {
  return (
    <Toolbar>
      <InputLabel htmlFor="user-type-select">User Type:</InputLabel>
      <Select
        value={userType}
        onChange={handleUserTypeChange}
        inputProps={{
          name: 'userType',
          id: 'user-type-select',
        }}
        autoWidth={true}
        defaultValue="all" 
        sx={{ marginLeft: '16px' }}>
        <MenuItem value="all">All</MenuItem>
        <MenuItem value="recommendation">Recommendation</MenuItem>
        <MenuItem value="registry">Registry</MenuItem>
      </Select>
      <StyledRoot>
        <StyledSearch
          value={filterName}
          onChange={onFilterName}
          placeholder="Search..."
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon fontSize="medium" />
            </InputAdornment>
          }
        />
      </StyledRoot>
    </Toolbar>
  );
}
